import { FormControl } from "@/shared/components/common/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/common/Select";
import { cn } from "@/shared/libs/commonUtils";
import type { HTMLAttributes } from "react";
import type { FieldValues } from "react-hook-form";

type ClassName = {
  select__value?: string;
  select__trigger?: string;
  select__Content?: string;
  select__item?: string;
};

interface SelectInputProps {
  props?: HTMLAttributes<HTMLSelectElement>;
  field: FieldValues;
  options: {
    name: string;
    value: string;
  }[];
  placeholder?: string;
  classNames?: ClassName;
}

export default function SelectInput({
  props,
  field,
  options,
  placeholder,
  classNames,
}: SelectInputProps) {
  return (
    <Select onValueChange={field.onChange} value={field.value as string}>
      <FormControl className="w-full">
        <SelectTrigger
          className={cn(
            "w-full h-12! rounded-sm border-border shadow-none",
            classNames?.select__trigger,
          )}
        >
          <SelectValue
            {...props}
            placeholder={placeholder}
            className={cn("", classNames?.select__value)}
          />
        </SelectTrigger>
      </FormControl>

      <SelectContent className={cn("rounded-sm", classNames?.select__Content)}>
        {options?.map(({ name, value }) => (
          <SelectItem
            key={value}
            value={value}
            className={cn("rounded-sm! p-3", classNames?.select__item)}
          >
            {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
